import { Link } from "react-router-dom";
import { Heart, BedDouble, Bath, Maximize } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function PropertyCard({ p }) {
  const { user, savedIds, toggleSave } = useAuth();
  const saved = savedIds.includes(p.id);

  const onSave = async (e) => {
    e.preventDefault();
    if (!user) { toast.error("Please sign in to save homes."); return; }
    await toggleSave(p.id);
    toast.success(saved ? "Removed from saved homes" : "Saved to your homes");
  };

  return (
    <Link to={`/property/${p.id}`} data-testid={`property-card-${p.id}`} className="group block bg-white rounded-2xl overflow-hidden border border-black/5 shadow-[0_8px_40px_rgba(0,0,0,0.03)] hover:-translate-y-1 transition-transform">
      <div className="relative h-52 overflow-hidden">
        <img src={p.image} alt={p.address} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        {p.newConstruction && <span className="absolute top-3 left-3 bg-green text-white text-xs font-medium px-3 py-1 rounded-full">New Construction</span>}
        <button onClick={onSave} data-testid={`save-btn-${p.id}`} aria-label="Save home"
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center hover:scale-110 transition-transform">
          <Heart size={18} className={saved ? "fill-gold text-gold" : "text-navy"} />
        </button>
      </div>
      <div className="p-5">
        <div className="font-serif text-2xl text-navy">${p.price.toLocaleString()}</div>
        <div className="text-charcoal/70 text-sm mt-1">{p.address}, {p.city}</div>
        <div className="flex items-center gap-4 mt-3 text-charcoal/60 text-sm font-mono">
          <span className="flex items-center gap-1"><BedDouble size={15} /> {p.beds}</span>
          <span className="flex items-center gap-1"><Bath size={15} /> {p.baths}</span>
          <span className="flex items-center gap-1"><Maximize size={15} /> {p.sqft.toLocaleString()} sf</span>
        </div>
        <div className="mt-3 text-xs text-charcoal/40 uppercase tracking-wider">{p.type}</div>
      </div>
    </Link>
  );
}
